<template>
  <div class="rescue global-rescue">
    <BackTop></BackTop>
    <div class="main">
      <Breadcrumb class="bread rescueBread"
                  separator=">">
        <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem>
        <BreadcrumbItem to="/rescue">全球救援</BreadcrumbItem>
        <BreadcrumbItem class="bread-last">企业法人会员服务</BreadcrumbItem>
      </Breadcrumb>
      <h3 class="rescue-bigtitle"
          style="margin-bottom:39px;">企业法人会员服务</h3>
      <p class="experience-para"
         style="margin-bottom:30px;">威马捷为驻扎海外及出差的会员提供医疗救援服务。服务内容不仅有紧急事故发生时的紧急救援服务，还包括前期进行的信息收集和境外医疗健康咨询，以及医疗转运和归国后的医院安排等配套服务。无论保险是否能够理赔，从预防保健到治疗后的关怀，威马捷全面地为会员提供援助服务，保障安心。
      </p>
      <div class="member-between">
        <img :src="member02"
             alt="">
        <img :src="member01"
             alt="">
      </div>
      <h4 class="rescue-title">医疗咨询服务</h4>
      <p class="experience-para"
         style="margin-bottom:28px;">调查当地医疗信息，整理当地最佳转运地等紧急医疗转运信息，并制作紧急医疗转运方案。</p>
      <div class="personalized-list">
        <div class="personal-cell"
             v-for="(service,index) in services"
             :key="index">
          <h5>{{service.title}}</h5>
          <p>{{service.info}}</p>
        </div>
      </div>
      <h4 class="rescue-title">紧急救援服务</h4>
      <p class="experience-para"
         style="margin-bottom:28px;">提供预约医院，医疗翻译，医疗费垫付，医疗转运等各种救援服务。 </p>
      <div class="personalized-list">
        <div class="personal-item"
             v-for="(aid,index) in aids"
             :key="index">
          <h5>{{aid.title}}</h5>
          <p>{{aid.info}}</p>
        </div>
      </div>
      <h4 class="rescue-title">会员专属信息页面</h4>
      <div class="experience-part"
           style="padding:0;">
        <p class="experience-para"
           style="margin-bottom:0;">威马捷根据会员需求，对指定地区的医疗信息进行提取及整理做成专属页面。并为每位会员设置专属的会员页面登录ID，会员登录专属页面后可随时自行浏览。</p>
        <p class="experience-para"
           style="margin-bottom:0;">其中网罗的不止有医院详细信息，还包括各国出行前及回国后的健康常识，需要注意的流行疾病和常备药品，最新安全信息，当地健康体检及预防接种等健康管理信息及EAJ服务介绍。</p>
        <p class="experience-para"
           style="margin:33px auto 110px auto;">威马捷正在加速服务电子化的进程。在线服务实现后，会员可登录手机客户端随时浏览专属信息，同时可以通过客户端的案件管理系统自行录入案件信息并享受简单案件的在线自助预约及挂账服务。在线服务的改革将会给客户带来更加便利的理赔体验。</p>
      </div>
      <a class="more-cases"
         @click="toGuide">&nbsp;&nbsp;医疗救援服务案例>></a>
    </div>
  </div>
</template>
<script>
import member01 from '@/assets/images/rescue/member01.jpg'
import member02 from '@/assets/images/rescue/member02.jpg'
export default {
  data () {
    return {
      member01,
      member02,
      services: [
        { title: '信息调查', info: '调查现地医院信息，体检及预防接种相关信息，紧急救护相关信息并整理制作资料。' },
        { title: '制作紧急转运方案', info: '制作并提供会员在发生急重症案件时就医及海外紧急转运/归国医疗转运的方案。' }
      ],
      aids: [
        { title: '安排就医', info: '为会员介绍并安排最适合的医疗机构就诊。' },
        { title: '翻译服务', info: '通过电话翻译以及派遣现场翻译人员，为会员提供医疗翻译服务，协助与现地医护人员的沟通。' },
        { title: '治疗费的挂账及代垫服务', info: '为会员提供治疗费的挂账，减额交涉，以及代理支付服务。并根据需求为会员提供合理利用保险的建议。' },
        { title: '治疗监护', info: '会员住院期间，由威马捷顾问医生定期与当地主治医生取得联系，实时把握患者治疗情况' },
        { title: '当地治疗评价及建议', info: '由威马捷顾问医生就当地治疗情况作出医疗专业解析，并给出建议。' },
        { title: '医疗人员的派遣', info: '根据需求，派遣相应的医疗人员赶赴当地。' },
        { title: '紧急医疗转运', info: '如果当地医疗环境无法为会员提供所需的治疗，威马捷会为患者提供紧急转运，重症患者将会根据情况安排患者在医护人员陪同下转运回国。' },
        { title: '安排转运接收医院', info: '安排转运目的地的接收医院，尤其对于转运后需要持续治疗的会员，确保病床对病床的无缝对接。' },
        { title: '遗体处理及转运', info: '会员不幸身故时，威马捷会协助客户进行遗体处理，根据需求安排当地埋葬，火葬或者遗体转运回国。' },
        { title: '保险理赔手续', info: '如果会员持有相关保险产品，威马捷可代理客户完成保险理赔手续。' },
      ]
    }
  },
  mounted () {

  },
  methods: {
    toGuide () {
      localStorage.setItem('linkId', 'one')
      this.$router.push({
        path: '/rescueOfCustomerService'
      })
    }
  }
}
</script>
<style lang="less">
.service-list {
  width: 280px;
  margin: 0 auto;
  li {
    position: relative;
    font-size: 24px;
    color: #333130;
    line-height: 30px;
    padding-left: 18px;
    &:first-child {
      background: url('../assets/images/rescue/worldnet6.jpg') no-repeat left
        center;
    }
    &:nth-child(n + 2) {
      span {
        position: absolute;
        left: 0;
        top: 10px;
        display: block;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background: #ff0000;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.more-cases {
  display: inline-block;
  width: 217px;
  height: 38px;
  line-height: 38px;
  background: url('../assets/images/home/head-vip.jpg') no-repeat right;
  color: #fff;
  font-size: 20px;
  margin-bottom: 100px;
  cursor: pointer;
}

.experience-part {
  border: none;
}
.member-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 906px;
  margin: 0px auto 100px auto;
  p,
  div {
    flex: 1;
  }
}
.personalized-list {
  width: 928px;
  display: table;
  margin: 0 auto 100px auto;
  .personal-cell {
    width: 447px;
    height: 200px;
    float: left;
    border: 1px solid #e9ebf4;
    margin-bottom: 0;
    margin-right: 29px;
    padding: 0;
    box-sizing: border-box;
    &:nth-child(2n + 2) {
      margin-right: 0;
    }
    h5 {
      font-size: 20px;
      color: #333130;
      line-height: 60px;
      height: 60px;
      background: #e9ebf4;
      padding: 0 9px;
      margin-bottom: 0;
    }
    p {
      font-size: 16px;
      color: #333130;
      padding: 20px 9px;
      color: #333130;
      line-height: 32px;
    }
  }
  .personal-item {
    width: 290px;
    height: 224px !important;
    margin-bottom: 20px;
    box-sizing: border-box;
    float: left;
    border: 1px solid #e9ebf4;
    margin-right: 29px;
    padding: 0;
    box-sizing: border-box;
    &:nth-child(3n + 3) {
      margin-right: 0;
    }

    h5 {
      font-size: 20px;
      color: #333130;
      line-height: 60px;
      height: 60px;
      background: #e9ebf4;
      padding: 0 9px;
      margin-bottom: 0;
    }
    p {
      font-size: 16px;
      color: #333130;
      padding: 20px 9px;
      color: #333130;
      line-height: 32px;
    }
  }
}
</style>